module.exports = __webpack_public_path__ + "img/article-mini-banner.80be616.jpg";